import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Style.
 */

const StyledGradientCellDiv = styled.div`
  position: sticky;
  top: 0;
  right: 0;
  bottom: 0px;
  background: linear-gradient(270deg, ${(p) => p.theme.foreground} 0%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;

  // Set the width then offset it so we do not change the row's width
  flex: 0 0 40px;
  margin-left: -40px;
`;

/*
 * Component.
 */

export const RightOverflowGradient: FC = () => <StyledGradientCellDiv />;
